import Modal from 'apollo-react/components/Modal';
import React from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';
import { getUITA } from '../../utils/commonUtils';

export const WarningModal = ({ open, setWarningModalOpen, onConfirmClick }) => {
  const translateString = useTranslation();

  return (
    <Modal
      open={open}
      onClose={() => setWarningModalOpen(false)}
      variant="warning"
      title={translateString('Warning')}
      message={translateString(
        'This should only be used for scenarios when the task terminates with error without updating the status in the database, usually we see "Thread abort Exception" in the log. Use this to rerun the installation. This will not cancel the on going installation task.'
      )}
      disableBackdropClick
      disableEscapeKeyDown
      buttonProps={[
        {
          variant: 'secondary',
          label: translateString('Cancel'),
        },
        {
          variant: 'primary',
          label: translateString('Ok'),
          onClick: () => onConfirmClick(),
        },
      ]}
      ui-ta={getUITA('ResetUpgradeWarningModal')}
    />
  );
};
